import type { PulseKpi } from './types';
export function assess(kpi: PulseKpi, value: number | null | undefined): boolean | null {
  if (value == null || !Number.isFinite(value)) return null;
  const goal = kpi.goal_value, min = kpi.goal_min, max = kpi.goal_max;
  switch (kpi.orientation_rule) {
    case 'gte_goal': return goal == null ? null : value >= goal;
    case 'lte_goal': return goal == null ? null : value <= goal;
    case 'eq_goal': return goal == null ? null : value === goal;
    case 'inside_range': return min == null || max == null ? null : value >= min && value <= max;
    case 'outside_range': return min == null || max == null ? null : value < min || value > max;
    default: return null;
  }
}
export function formatValue(value: number | null | undefined, kpi: Pick<PulseKpi, 'number_format' | 'goal_unit'>, language: string): string {
  if (value == null || !Number.isFinite(value)) return '—';
  const decimals = kpi.number_format === 'integer' ? 0 : kpi.number_format === 'decimal_1' ? 1 : 2;
  const formatted = new Intl.NumberFormat(language.startsWith('fr') ? 'fr-CA' : 'en-CA', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: kpi.number_format === 'decimal_1' || kpi.number_format === 'decimal_2' ? decimals : 0,
    notation: kpi.number_format === 'auto' ? 'compact' : 'standard',
  }).format(value);
  return kpi.goal_unit ? `${formatted}${kpi.goal_unit === '%' ? '' : ' '}${kpi.goal_unit}` : formatted;
}
